<div class="player">
  <button class="play-btn" [disabled]="isLoading" (click)="isPlaying ? pause() : play()">
    <ng-container *ngIf="!isPlaying">
      <span class="ikona-play" mmIkonaSvg="play2"></span>
    </ng-container>

    <ng-container *ngIf="isPlaying">
      <span class="ikona-play" mmIkonaSvg="pause2"></span>
    </ng-container>
  </button>

  <input class="seek" type="range" min="0" [max]="duration" step="0.01" [value]="currentTime" [disabled]="isSeeking"
    [style.--val]="(currentTime / duration) * 100" (input)="seekTo($any($event.target).value)" />

  <div class="time">
    <ng-container *ngIf="!isLoading && !isSeeking; else loadingTpl">
      {{ currentTimeHuman }} / {{ durationHuman }}
    </ng-container>

    <ng-template #loadingTpl>
      <mat-spinner diameter="16" strokeWidth="3"></mat-spinner>
    </ng-template>
  </div>

  <div class="volume">
    <button class="volume-btn" (click)="onVolumeIconClick()">
      <ng-container *ngIf="volume > 0; else mutedIcon">
        <span class="volume-ikona" mmIkonaSvg="volume"></span>
      </ng-container>
      <ng-template #mutedIcon>
        <span class="volume-ikona" mmIkonaSvg="muted"></span>
      </ng-template>
    </button>

    <div class="volume-slider" *ngIf="showVolume">
      <input type="range" min="0" max="1" step="0.01" [value]="volume" [style.--val]="volume * 100"
        (input)="setVolume($any($event.target).value)" />
      <span class="percent">{{ (volume * 100) | number:'1.0-0' }}%</span>
    </div>
  </div>

  <div class="options">
    <button class="options-btn" (click)="showOptions = !showOptions">
      <span class="options-ikona" mmIkonaSvg="dots"></span>
    </button>
    <div class="dropdown" *ngIf="showOptions">
      <button (click)="downloadFile()" class="flex items-center">
        <span class="ikona-small" mmIkonaSvg="download"></span>
        Pobierz
      </button>

      <!-- <label class="flex items-center">
        <span class="ikona-small" mmIkonaSvg="play_slow"></span>Prędkość:
        <div class="speed">
          <button class="speed-btn ml-1 font-bold" (click)="showSpeed = !showSpeed">
            {{ speed }}×
          </button>
          <div class="speed-submenu" *ngIf="showSpeed">
            <button *ngFor="let s of speedOptions" (click)="setSpeed(s); showSpeed = false; showOptions = false"
              [class.active]="speed === s">
              {{ s }}×
              <span *ngIf="speed === s">✔</span>
            </button>
          </div>
        </div>
      </label> -->
    </div>
  </div>
</div>
